export default __webpack_public_path__ + "static/N0035-c385b35ca85243be16057960f70cdbf6.png";